import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Modal,
  Typography,
} from '@mui/material';
import { getDispatchDetails } from 'redux/actions/OperationsAction';
import { getReservationDetails } from 'redux/actions/reservationAction';
import CommonButton from 'components/commonButton/CommonButton';
import Loader from 'components/loader/Loader';
import {
  getDateFormat,
  getTimeFormat,
  getReservationDetailsObject,
} from 'utils/utils';
import { tableHeader } from './AllotData';

const DispatchModal = ({ open, toggle, tripDetails, page, payload }) => {
  const [checkBoxSelect, setCheckboxSelect] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setCheckboxSelect(false);
    if (tripDetails?.id) {
      if (page === 'listPage' || page === 'allot') {
        dispatch(getReservationDetails(tripDetails?.id));
      }
    }
  }, [open]);

  const reservationDetails = useSelector(
    (state) => state.getReservationDetails?.reservationDetails?.data
  );
  const mappingData = reservationDetails?.id ? reservationDetails : tripDetails;

  const handleClose = () => {
    toggle();
  };

  const handleApply = () => {
    const tripId = {
      tripId: tripDetails?.id ? tripDetails?.id : '',
    };

    dispatch(getDispatchDetails(tripId, page, payload));
    handleClose();
  };

  const onClose = () => {
    handleClose();
  };

  // ----FormatingDate---
  const handleDateFormating = (data) => {
    return getDateFormat(data);
  };

  //---Time Format---
  const handleTimeFormat = (date) => {
    return getTimeFormat(date);
  };

  return (
    <Modal
      open={open || false}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="customModal"
    >
      <Box
        className="modalContent dispatchModalContent textLeft"
        sx={{ height: { xs: '100%', sm: 'auto' } }}
      >
        {mappingData?.id ? (
          <Box className="modalContentWrapper">
            <Typography
              variant="head5"
              component={'h1'}
              className="colorPrimary fw600 mb10"
            >
              Dispatching trip for {reservationDetails?.tripId}
            </Typography>
            <Typography
              variant="body1"
              component={'h3'}
              className="colorBlack fw400 mb10"
            >
              Use this to send SMS and Email notifications to passengers
            </Typography>

            <Grid container className="mb20 mt30">
              {tableHeader &&
                tableHeader.map((index) => (
                  <Grid
                    item
                    xs={4}
                    className="commonBorder textCenter ptb10"
                    key={index}
                  >
                    <Typography variant={'body3'} className="colorGrey">
                      {index}
                    </Typography>
                  </Grid>
                ))}
              <Grid item xs={4} className="commonBorder textCenter ptb10">
                <Typography variant={'body3'} className="colorBlack">
                  {mappingData?.customerName || 'NA'}
                </Typography>
              </Grid>
              <Grid item xs={4} className="commonBorder textCenter ptb10">
                <Typography variant={'body3'} className="colorBlack">
                  {`${mappingData?.Employee?.countryCode}${mappingData?.customerPhone|| "NA"}`} {}
                </Typography>
              </Grid>
              <Grid item xs={4} className="commonBorder textCenter ptb10">
                <Typography variant={'body3'} className="colorBlack">
                  {mappingData?.customerEmail ||'NA'}
                </Typography>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12} md={1.5}>
                <Typography variant={'head5'}>Message</Typography>
              </Grid>

              <Grid item xs={12} md={10.5}>
                <Typography variant={'body2'} className="colorPrimary ptb5">
                  Vehicle & Driver Details
                </Typography>
                <Typography variant={'body2'} className="pb10">
                  <span className="colorGrey">Passenger : </span>
                  {mappingData?.customerName} ({mappingData?.Employee?.countryCode}{mappingData?.customerPhone})
                </Typography>
                <Typography variant={'body2'} className="pb10">
                  <span className="colorGrey">Driver : </span>
                  {`${mappingData?.DriverProfile?.firstName} ${mappingData?.DriverProfile?.lastName} (${mappingData?.DriverProfile?.mobile})`}
                </Typography>
                <Typography variant={'body2'} className="pb10">
                  <span className="colorGrey">Vehicle : </span>
                  {mappingData?.DriverProfile?.Vehicle?.carType}
                </Typography>
                <Typography variant={'body2'} className="pb10">
                  <span className="colorGrey">Reporting on : </span>
                  {mappingData?.scheduledTime
                    ? `${handleDateFormating(
                        mappingData?.scheduledTime
                      )}  ${handleTimeFormat(mappingData?.scheduledTime)} `
                    : ''}
                </Typography>
                <Typography variant={'body2'} className="pb10">
                  <span className="colorGrey">Reporting Address: </span>
                  {mappingData?.sourceAddress || 'NA'}
                </Typography>
                <Typography variant={'body2'} className="pb10">
                  <span className="colorGrey">Landmark: </span>
                  {mappingData?.sourceLandMarkAddress|| 'NA'}
                </Typography>
                <Typography variant={'body2'} className="pb10">
                  <span className="colorGrey">Drop Address : </span>
                  {mappingData?.destinationAddress || 'NA'}
                </Typography>
                <Typography variant={'body2'} className="pb10">
                  <span className="colorGrey">Special Instruction : </span>
                  <Typography variant='span' className="colorPrimary fw700">{mappingData?.note || 'NA'}</Typography>
                </Typography>
              </Grid>
            </Grid>
            <Box className="dashedBorder mt10 mb20"></Box>

            <FormControlLabel
              control={
                <Checkbox
                  checked={checkBoxSelect}
                  onChange={(event) => setCheckboxSelect(event.target.checked)}
                />
              }
              label="All the above-mentioned details have been verified, and the vehicle is ready to be dispatched."
            />
            <Grid container justifyContent={'flex-end'}>
              <CommonButton
                name="Close"
                btnClass={'btnMedium btnTransparent'}
                onClick={onClose}
              />
              <CommonButton
                name="Send"
                btnClass={'btnMedium'}
                disabled={!checkBoxSelect}
                onClick={handleApply}
              />
            </Grid>
          </Box>
        ) : (
          <Loader height={'30vh'} />
        )}
      </Box>
    </Modal>
  );
};

export default DispatchModal;